import { environmentSelector } from '../selectors/commonSelectors';
import useAppSelector from './useAppSelector';

export const useAccountActivityState = () => {
    const { isState } = useAppSelector(environmentSelector);

    const defaultValues = {
        isLinkForEventName: true,
        borderSize: '2px',
    };

    switch (true) {
        case isState.ID:
        case isState.NJ:
        case isState.NV:
            return {
                ...defaultValues,
                borderSize: '1px',
            };
        case isState.MN:
            return {
                ...defaultValues,
                isLinkForEventName: false,
                borderSize: '1px',
            };
        default:
            return defaultValues;
    }
};
